/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Font_Family_LabelInputs */

const en_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Font Family`)
};

const fr_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famille de polices`)
};

const de_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftfamilie`)
};

const it_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famiglia di caratteri`)
};

const ru_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семейство шрифтов`)
};

const es_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familia de fuentes`)
};

const zh_cn2_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字体系列`)
};

const ja_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントファミリー`)
};

const hi_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फुहारा परिवार`)
};

const pt_pt2_edit_event_group_font_family_label = /** @type {(inputs: Edit_Event_Group_Font_Family_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Família de fontes`)
};

/**
* | output |
* | --- |
* | "Font Family" |
*
* @param {Edit_Event_Group_Font_Family_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_font_family_label = /** @type {((inputs?: Edit_Event_Group_Font_Family_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Font_Family_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_font_family_label(inputs)
	if (locale === "de") return de_edit_event_group_font_family_label(inputs)
	if (locale === "it") return it_edit_event_group_font_family_label(inputs)
	if (locale === "ru") return ru_edit_event_group_font_family_label(inputs)
	if (locale === "es") return es_edit_event_group_font_family_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_font_family_label(inputs)
	if (locale === "ja") return ja_edit_event_group_font_family_label(inputs)
	if (locale === "hi") return hi_edit_event_group_font_family_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_font_family_label(inputs)
	return en_edit_event_group_font_family_label(inputs)
});